<div>
	@if (isLocked) {
		<div class="row">
			<div class="col-12">
				{{ "record_is_locked" | langVal }}
			</div>
		</div>
	}

	<div class="form-grid">
		<div class="d-flex form-grid-section">
			<div class="colstat colstat-small">
				<label>{{ "number" | langVal }}</label>
				<app-gen-input
					[actualObj]="patient"
					disabled
					[errors]="errors"
					fieldName="id"
					title_ph_lang="number"
				>
				</app-gen-input>
			</div>
			<div class="colstat colstat-big">
				<label>{{ "patient_name" | langVal }}</label>

				<app-gen-input
					tabindex="-1"
					autocomplete="off"
					[disabled]="isLocked"
					[actualObj]="patient"
					[errors]="errors"
					fieldName="name"
					title_ph_lang="patient_name"
					(keyupEvent)="
						nameChangeConfirmHappened ? validateAndSave() : nameSubj.next(true)
					"
				>
				</app-gen-input>
			</div>

			@if (insert_patient_template.id_number) {
				<div class="colstat-small">
					<label>{{ "id_number" | langVal }}</label>
					<app-gen-input
						tabindex="3"
						[actualObj]="patient"
						[errors]="errors"
						[disabled]="isLocked"
						fieldName="id_number"
						(keyupEvent)="validateAndSave()"
					>
					</app-gen-input>
				</div>
			}
			@if (insert_patient_template.gender) {
				<div class="colstat-big">
					<label>{{ "gender" | langVal }}</label>
					<app-gen-button-group
						[actualObj]="patient"
						fieldName="gender"
						optionsListName="gender_opts"
						[disabled]="isLocked"
						(changeEvent)="validateAndSave()"
					></app-gen-button-group>
				</div>
			}

			<div class="colstat colstat-small pad-btns">
				<app-gen-button-group
					[actualObj]="patient"
					fieldName="status"
					optionsListName="patient_or_inquirer_opts"
					[disabled]="isLocked"
					(changeEvent)="validateAndSave()"
				></app-gen-button-group>
			</div>
		</div>
		<div class="d-flex form-grid-section">
			@if (
				insert_patient_template.payor_id && permsService?.perms?.administrative
			) {
				<div class="colstat colstat-big">
					<label>{{ "payor" | langVal }}</label>
					<app-gen-autocomplete
						#payorFuzzyInput
						title_ph_lang="payor"
						[actualObj]="patient"
						fieldName="payor_id"
						[disabled]="isLocked"
						tabindex="-1"
						[fuzzySearchableClasses]="['payors']"
						[error]="errors.payor_id"
						(chosenEvent)="validateAndSave()"
						[hasPlus]="
							$safeNavigationMigration(permsService?.perms?.administrative)
						"
						plusLang="add_payor"
						(plusClick)="openAddPayorModal()"
					></app-gen-autocomplete>
				</div>
			}
		</div>
		@if (patientfields?.length) {
			<div class="d-flex align-items-start gap-2">
				@for (patientfield of patientfields; track patientfield) {
					<div class="colstat colstat-small-double">
						<label>{{ patientfield.name | langVal }}</label>
						@switch (patientfield.type) {
							@case ("text") {
								<app-ta-expands
									#taExpands
									[actualObj]="patient"
									[errors]="errors"
									[disabled]="isLocked"
									[fieldName]="'patientfield_id_' + patientfield.id"
									[title_ph_lang]="patientfield.name"
									(keyupEvent)="validateAndSave()"
								/>
							}
							@case ("opts-checkbox") {
								<div
									class="d-grid gap-2"
									style="margin-inline-start: 8px; padding-top: 4px"
								>
									@for (opt of patientfield.optsArr; track opt) {
										<p class="d-flex flex-nowrap align-items-start gap-2">
											<input
												type="radio"
												[name]="'patientfield_id_' + patientfield.id"
												(click)="
													patient['patientfield_id_' + patientfield.id] =
														opt.value;
													validateAndSave()
												"
												[checked]="
													patient['patientfield_id_' + patientfield.id] ==
													opt.value
												"
											/>
											{{ opt.value }}
										</p>
									}
								</div>
							}
							@case ("opts-btn-group") {
								<app-gen-button-group
									[actualObj]="patient"
									[fieldName]="'patientfield_id_' + patientfield.id"
									optionFieldValue="value"
									optionFieldName="value"
									[errors]="errors"
									[options]="patientfield.optsArr"
									(changeEvent)="validateAndSave()"
								/>
							}
						}
					</div>
				}
			</div>
		}
		<hr />
		@if (permsService?.perms?.administrative && permsService.owner_has_users) {
			<div class="d-flex form-grid-section">
				<!--				<div class="colstat colstat-big">-->
				<!--					<label>{{ "filter_sub_users" | langVal }}</label>-->
				<!--					<app-autocomplete-with-tags-->
				<!--						(chosenEvent)="updateExcludedIds($event)"-->
				<!--						title_ph_lang="filter_sub_users"-->
				<!--					/>-->
				<!--				</div>-->

				<div class="colstat-small colstat">
					<label>{{ "therapist" | langVal }}</label>
					@if (filterSubUsersOpen) {
						<app-autocomplete-with-tags
							(chosenEvent)="updateExcludedIds($event)"
							title_ph_lang="filter_sub_users"
							class="meeting-filter"
							#subUsersAC
						/>
					} @else {
						<button
							titleLang="filter_sub_users"
							class="btn btn-icon"
							(click)="openFilterSubUsers()"
							icon="filter"
						></button>
					}
				</div>
				<div class="colstat colstat-big">
					<label>{{ "assign_sub_users" | langVal }}</label>
					<app-autocomplete-multi
						[ids]="patient?.assoc || []"
						(addItem)="assocAddItem($event)"
						title_ph_lang="assign_sub_users"
						[isStatic]="isLocked"
						siteDataTable="sub_users"
						[siteDataFilters]="{ active: 'yes' }"
						(deleteItem)="assocDeleteItem($event)"
						[excludeIds]="excludeIds"
					/>
				</div>
			</div>
		}

		<div class="d-flex form-grid-section">
			@if (insert_patient_template.date_of_birth) {
				<div class="col-4 col-md-2 colstat">
					<label>{{ "date_of_birth" | langVal }}</label>
					<app-date-picker
						[actualObj]="patient"
						[errors]="errors"
						fieldName="date_of_birth"
						[disabled]="isLocked"
						startFromDecade
						isFullYear
						tabindex="-1"
						(changeEvent)="validateAndSave()"
						[addonObject]="{ after: { icon: 'calendar' } }"
					/>
				</div>
			}
			@if (insert_patient_template.year_of_birth) {
				<div class="col-4 col-md-2 colstat">
					<label>{{ "year_of_birth" | langVal }}</label>
					<app-gen-input
						tabindex="4"
						[actualObj]="patient"
						[errors]="errors"
						[disabled]="isLocked || patient.date_of_birth"
						fieldName="year_of_birth"
						(keyupEvent)="validateAndSave()"
					>
					</app-gen-input>
				</div>
			}
			@if (patient.year_of_birth || patient.date_of_birth) {
				<div class="colstat colstat-small">
					<label>{{ "age" | langVal }}</label>
					<app-gen-input
						[actualObj]="patient"
						fieldName="age"
						disabled
					/>
				</div>
			}
			@if (insert_patient_template.number_of_kids) {
				<div class="colstat colstat-small">
					<label>{{ "number_of_kids" | langVal }}</label>
					<app-gen-input
						tabindex="6"
						[actualObj]="patient"
						[errors]="errors"
						[disabled]="isLocked"
						fieldName="number_of_kids"
						(keyupEvent)="validateAndSave()"
					>
					</app-gen-input>
				</div>
			}
		</div>

		<div class="d-flex form-grid-section">
			@if (insert_patient_template.marital_status) {
				<div class="colstat colstat-small-triple pad-btns">
					<label>{{ "marital_status" | langVal }}</label>
					<app-gen-button-group
						[actualObj]="patient"
						fieldName="marital_status"
						optionsListName="marital_status_opts"
						[disabled]="isLocked"
						(changeEvent)="validateAndSave()"
					/>
				</div>
			}

			@if (insert_patient_template.parents_marital_status) {
				<div class="colstat colstat-small-triple pad-btns">
					<label>{{ "parents_marital_status" | langVal }}</label>
					<app-gen-button-group
						[actualObj]="patient"
						fieldName="parents_marital_status"
						optionsListName="parents_marital_status_opts"
						[disabled]="isLocked"
						(changeEvent)="validateAndSave()"
					/>
				</div>
			}
		</div>

		<div class="d-flex form-grid-section">
			@if (insert_patient_template.name_en) {
				<div class="colstat colstat-big">
					<label>{{ "name_en" | langVal }}</label>
					<app-gen-input
						tabindex="-1"
						className="text-left"
						[actualObj]="patient"
						[disabled]="isLocked"
						[errors]="errors"
						fieldName="name_en"
						(keyupEvent)="validateAndSave()"
					>
					</app-gen-input>
				</div>
			}

			@if (insert_patient_template.address) {
				<div class="colstat colstat-small-triple">
					<label>{{ "address" | langVal }}</label>
					<app-gen-input
						tabindex="-1"
						className="text-left"
						[actualObj]="patient"
						[disabled]="isLocked"
						[errors]="errors"
						fieldName="address"
						(keyupEvent)="validateAndSave()"
					>
					</app-gen-input>
				</div>
			}
		</div>
		<div class="d-flex form-grid-section">
			@if (insert_patient_template.notifiy) {
				<div class="colstat colstat-small">
					<div>
						<label (click)="changeYesNo('notifiy')">{{
							"notifiy" | langVal
						}}</label>
						<app-yes-no
							(onClick)="changeYesNo('notifiy')"
							[isCheck]="patient.notifiy == 'yes'"
						></app-yes-no>
					</div>
				</div>
			}
			@if (insert_patient_template.notification_default) {
				<div class="colstat colstat-small">
					<label>{{ "notification_default" | langVal }}</label>
					<div>
						<app-gen-button-group
							[actualObj]="patient"
							fieldName="notification_default"
							optionsListName="notification_defaultOpts"
							[disabled]="isLocked"
							(changeEvent)="validateAndSave()"
						/>
					</div>
				</div>
			}

			@if (insert_patient_template.automatic_proforma) {
				<div class="colstat colstat-big pad-btns">
					<app-gen-button-group
						[actualObj]="patient"
						fieldName="automatic_proforma"
						optionsListName="automatic_proforma_opts"
						[disabled]="isLocked"
						(changeEvent)="validateAndSave()"
					/>
				</div>
			}
		</div>
		@if (
			insert_patient_template.referer && permsService?.perms?.administrative
		) {
			<div class="d-flex form-grid-section">
				<div class="">
					<button
						titleLang="referers"
						tabindex="-1"
						class="btn btn-primary"
						(click)="modalProps = { name: 'table-display-refererpatients' }"
					>
						{{ "referers" | langVal }}
					</button>
					@if (permsService.owner_has_users) {
						<button
							titleLang="apotropuses"
							tabindex="-1"
							class="btn btn-primary"
							(click)="modalProps = { name: 'table-display-apotropuses' }"
						>
							{{ "apotropuses" | langVal }}
						</button>
					}
				</div>
			</div>
		}
		<div class="d-flex form-grid-section">
			<!--this was made for  user 2149 consider if to keep-->
			<div class="colstat colstat-small">
				<label>{{ "date_start_therapy" | langVal }}</label>
				<app-date-picker
					[actualObj]="patient"
					[errors]="errors"
					fieldName="date_start_therapy"
					[disabled]="isLocked"
					isFullYear
					tabindex="-1"
					(changeEvent)="validateAndSave()"
					[addonObject]="{ after: { icon: 'calendar' } }"
				>
				</app-date-picker>
			</div>
			<div class="colstat colstat-small">
				<label>{{ "created_at" | langVal }}</label>
				<div style="padding: 6px">
					{{ patient.created_at | dateFormat }}
				</div>
			</div>
			<div class="colstat colstat-big pad-btns">
				<app-gen-button-group
					[actualObj]="patient"
					fieldName="active"
					optionsListName="patient_active_insert_opts"
					[disabled]="isLocked"
					(changeEvent)="validateAndSave()"
				></app-gen-button-group>
			</div>
		</div>
		@if (insert_patient_template.remarks) {
			<div class="d-flex form-grid-section">
				<div class="col-12">
					<label>{{ "remarks" | langVal }}</label>
					<app-wysiwyg
						#remarksWysiwyg
						[actualObj]="patient"
						fieldName="remarks"
						tabindex="-1"
						[isStatic]="isLocked"
						(keyupEvent)="validateAndSave()"
						hasCharCounter
					/>
				</div>
			</div>
		}
		@if (insert_patient_template.tags) {
			<div class="d-flex form-grid-section">
				<div class="">
					<label>{{ "tags" | langVal }}</label>
					<app-autocomplete-with-tags
						(chosenEvent)="chooseTags($event)"
						title_ph_lang="tags"
						[objs]="tags"
						[isStatic]="isLocked"
						hasPlus
					/>
				</div>
			</div>
		}
		<div class="d-flex form-grid-section">
			@if (insert_patient_template.is_withholding_tax) {
				<div class="colstat colstat-big pad-btns">
					<app-gen-button-group
						[actualObj]="patient"
						fieldName="is_withholding_tax"
						optionsListName="is_withholding_tax_opts"
						[disabled]="isLocked"
						(changeEvent)="validateAndSave()"
					/>
				</div>
			}
			@if (insert_patient_template.withholding_tax_percent) {
				<div class="colstat colstat-small">
					<label>{{ "withholding_tax_percent" | langVal }}</label>
					<app-gen-input
						tabindex="-1"
						[actualObj]="patient"
						[errors]="errors"
						[disabled]="isLocked"
						fieldName="withholding_tax_percent"
						(keyupEvent)="validateAndSave()"
					/>
				</div>
			}
		</div>
	</div>

	<div class="bottom-row-buttons mb-2">
		<div
			class="action-buttons p-0 d-flex justify-content-sm-end justify-content-between"
		>
			@if (permsService.perms?.administrative) {
				<button
					titleLang="invoice_short"
					tabindex="-1"
					class="btn btn-primary"
					(click)="addInvoiceEv.emit()"
					preIcon="money-white"
					isImg
				>
					{{ "invoice_short" | langVal }}
				</button>
				@if (permsService.owner_has_users) {
					<button
						titleLang="assoc"
						tabindex="-1"
						class="btn btn-primary"
						(click)="modalProps = { name: 'table-display-o2su' }"
						preIcon="user"
					>
						{{ "assoc" | langVal }}
					</button>
				}
			}
			@if (
				(permsService?.perms?.administrative ||
					permsService?.perms?.clinical) &&
				permsService.owner_has_users
			) {
				<button
					titleLang="tasks"
					tabindex="-1"
					class="btn btn-primary"
					(click)="modalProps = { name: 'task' }"
					preIcon="task"
				>
					{{ "tasks" | langVal }}
				</button>
			}

			<button
				titleLang="letter"
				tabindex="-1"
				class="btn btn-primary"
				(click)="addDocumentEv.emit()"
				preIcon="document-white"
				isImg
			>
				{{ "letter" | langVal }}
			</button>

			<button
				titleLang="upload_file"
				tabindex="-1"
				class="btn btn-primary"
				(click)="openUploadDocumentModalEv.emit()"
				preIcon="document-white"
				isImg
			>
				{{ "upload_file" | langVal }}
			</button>
			<!--			@if (!patient?.filled_stage || patient?.filled_stage == "invited") {-->
			<!--				@if (patient?.contactways?.length) {-->
			<!--					<button-->
			<!--						titleLang="send_invite_to_fill"-->
			<!--						tabindex="-1"-->
			<!--						class="btn btn-primary"-->
			<!--						(click)="sendInvite()"-->
			<!--					>-->
			<!--						{{ "send_invite_to_fill" | langVal }}-->
			<!--					</button>-->
			<!--				}-->
			<!--			}-->
			@if (!patient?.filled_stage || patient?.filled_stage == "invited") {
				@if (patient?.contactways?.length) {
					<button
						titleLang="send_invite_to_fill"
						tabindex="-1"
						class="btn btn-primary"
						(click)="modalProps = { name: 'invite-contactways' }"
					>
						<!-- invite-contactways -->
						<!-- invite-prep -->
						{{ "send_invite_to_fill" | langVal }}
					</button>
				}
			}
			@if (patient?.filled_stage == "received") {
				<app-btn-ext
					text="update_from_patient_form"
					[isSpin]="isApprovingPatientDetails"
					(clickEv)="
						isApprovingPatientDetails = true;
						store.sendFillDetailsApprove(patient.id)
					"
				/>
			}
			<!--  toKeep @if(permsService.perms?.administrative){
      <button titleLang="upload_file" tabindex="-1" class="btn btn-primary" (click)="sendInvite()">{{"send_invite" | langVal}}</button>
      } -->
		</div>
	</div>
</div>
@switch (modalProps?.name) {
	@case ("invite-prep") {
		<app-modal-wrap (onClose)="modalProps = null">
			<app-invite-prep
				(onClose)="modalProps = null; handleInvitePrepChoose($event)"
				hasTemplateChoice
			/>
		</app-modal-wrap>
	}
	@case ("task") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			modalWrapperClass="modal-650"
			title="tasks"
		>
			<app-task
				(onClose)="modalProps = null"
				[patientRow]="patient"
			/>
		</app-modal-wrap>
	}
	@case ("add-payor") {
		<app-modal-wrap
			(onClose)="modalProps = null; handleAddPayorClose()"
			title="payors"
			modalWrapperClass="modal-fit-content"
		>
			<app-gen-table-add-item
				(onClose)="modalProps = null; handleAddPayorClose($event)"
				tableName="payors"
				[fuzzyName]="modalProps.fuzzyName"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-apotropuses") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="apotropuses"
			modalWrapperClass="modal-wide"
		>
			<app-gen-table-display
				(onClose)="modalProps = null"
				tableName="apotropuses"
				filterField="patient_id"
				[objectRow]="patient"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-refererpatients") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="refererpatients"
			modalWrapperClass="modal-wide"
		>
			<app-gen-table-display
				(onClose)="modalProps = null"
				tableName="refererpatients"
				filterField="patient_id"
				[objectRow]="patient"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-o2su") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="object_to_sub_users"
			modalWrapperClass="modal-wide"
		>
			<app-gen-table-display
				(onClose)="modalProps = null"
				tableName="object_to_sub_users"
				filterField="item_id"
				[filterFieldApiObject]="{ item_type: 'patient' }"
				[objectRow]="patient"
			/>
		</app-modal-wrap>
	}
	@case ("table-display-contactways") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="contactways"
			modalWrapperClass="modal-800"
		>
			<app-gen-table-display
				(onClose)="sendInvite($event)"
				tableName="contactways"
				filterField="patient_id"
				[filterFieldValue]="patient.id"
				fieldNameInItemToDisplay="contactway"
				chooseOnlyOne
				[filterFieldOrs]="{ contactway_identifier: ['email', 'phone'] }"
			/>
		</app-modal-wrap>
	}
	@case ("invite-contactways") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="contactways"
			modalWrapperClass="modal-800"
		>
			<app-gen-table-display
				(onClose)="
					modalProps = null;
					$event?.length && store.sendInviteCommon($event, patient.id)
				"
				tableName="contactways"
				filterField="patient_id"
				[filterFieldValue]="patient.id"
				fieldNameInItemToDisplay="contactway"
				chooseOnlyOne
				[filterFieldOrs]="{ contactway_identifier: ['email', 'phone'] }"
			/>
		</app-modal-wrap>
	}
	@case ("confirm-name-change") {
		<app-modal-wrap
			(onClose)="modalProps = null; approveNameChange(false)"
			title="do_you_confirm_change"
			modalWrapperClass="confirm-modal-vert-center modal-narrow-width"
		>
			<app-confirm
				(onClose)="modalProps = null; approveNameChange($event)"
				[objectName]="patient.name"
			/>
		</app-modal-wrap>
	}
}
